import { Component, Ref, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { cart } from '@/theme/Cart';
import { disableBodyScrolling } from '@/utils/disableBodyScrolling';

@Component
export class ProductCardQuickAdd extends ThemeComponent {

    @Prop({default: window.scrollY}) scrollPosition!: number;

    @Ref() closeButton!: HTMLButtonElement;
    @Ref() quickAddContainer!: HTMLDivElement;

    init() {

        this.scrollPosition = window.scrollY;

        this.setCloseButtonListener();
        this.addOutsideClickListener();

    }

    /**
     * Listen for close button clicks
    */
    setCloseButtonListener() {
        // Listen for click on the quick add button
        if (this.closeButton) {
            this.$listen(this.closeButton, 'click', (e) => {
                this.handleButton();
            });
        }
    }

    /**
     * Handle quick add state
    */
    handleButton() {
        this.classList.remove('is-active');
        this.scrollPosition = disableBodyScrolling(false, this.scrollPosition);
    }

    addOutsideClickListener() {
        // Use native addEventListener instead of this.$listen for document
        document.addEventListener('click', (event) => {
            const target = event.target as HTMLElement;

            // Check if the clicked element is outside the quick add container
            if (this.quickAddContainer && !this.quickAddContainer.contains(target)) {
                this.handleButton();
            }
        });
    }
}
